import { useMemo, useState } from 'react';
import Subscribe from '@/shared/Subscribe/ui/Subscribe';
import { useMedia } from '@/common/service/hooks/useMedia';
import Layout from '@/shared/Layout/ui/Layout';
import { Container } from '@/common/ui/containers/Container';
import * as S from './PartnersPage.style';
import { List } from './List/List';
import { IPartnersInfoDestination } from '@/common/service/api/Partners/Partners.domain';
import { CommonPageMeta } from '@/screens/CommonPage/ui/commonPage/CommonPageMeta';
import Paragraph from '@/shared/Paragraph/ui/Paragraph';
import Link from 'next/link';
import { AnswersFAQ } from '@/screens/ActivityPage/ui/Answers/AnswersFAQ';
import partnersImg from '@/shared/images/HeroImages/Partners.jpg';
import { buildRootUrl } from '@/common/app/utils/urlsUtils';

export type PartnersPageProps = {
    data: IPartnersInfoDestination[];
};

export const PartnersPage = ({ data }: PartnersPageProps) => {
    const isMobileView = useMedia('(max-width: 991px)');
    const [indexItemOpen, setIndexItemOpen] = useState<number | undefined>(0);
    const pageTitle = `TripShock! Partners`;

    const openItem = (index: number, el: HTMLElement) => {
        if (isMobileView) {
            setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'center' }), 300);
        }

        if (indexItemOpen === index && isMobileView) {
            setIndexItemOpen(undefined);
            return;
        }

        setIndexItemOpen(index);
    };

    const rootUrl = useMemo(() => buildRootUrl('/patners/'), []);

    return (
        <Layout>
            <Container>
                <CommonPageMeta type="partners" title={pageTitle} />
                <>
                    <S.ParagraphWrapper>
                        <S.CommonTitle data-test-id="Title">{pageTitle}</S.CommonTitle>

                        <Paragraph id="paragraph-text">
                            <>
                                Our activity partners offer the hottest experiences combined with a
                                proven track record of service and reliability. Discover which
                                operators are currently partnered with TripShock, view their tours,
                                and book online on{' '}
                                <Link href="/" passHref>
                                    <S.StyledLink>Tripshock.com.</S.StyledLink>
                                </Link>
                            </>
                        </Paragraph>
                    </S.ParagraphWrapper>
                    <S.CommonWrapper data-test-id="Common_wrapper">
                        <List data={data} indexItemOpen={indexItemOpen} openItem={openItem} />
                    </S.CommonWrapper>
                </>
            </Container>
            <S.WrapperSubscribe>
                <Subscribe />
            </S.WrapperSubscribe>
            <AnswersFAQ title={pageTitle} url={rootUrl} image={partnersImg.src} id="partners" />
        </Layout>
    );
};
